// Build identity for the auto-reload mechanism.
//
// REACT_APP_BUILD_ID is injected at build time (see package.json build scripts).
// It must be a value that strictly increases per deploy so the running tab can tell
// whether the server is advertising a newer build than the one it is currently running.
// We use the build epoch-seconds (UTC) captured at build time — monotonic and human-readable.
//
// Fallback (0) means "unknown build": the reload check treats an unknown local build as
// always-stale-safe by NOT force-reloading on a zero, to avoid reload loops in dev.
export const BUILD_ID = Number(process.env.REACT_APP_BUILD_ID) || 0

// Where the server-side reload signal lives in Realtime Database.
// A tiny dedicated node so the always-on listener carries negligible egress.
export const RELOAD_CONFIG_PATH = 'config/delegationApp'
